import moment from 'moment-timezone';
import 'moment/min/locales';

export function parseMomentToString(dateTimeMoment, format) {
  if (dateTimeMoment instanceof moment) {
    return moment(dateTimeMoment).format(format);
  }
  if (dateTimeMoment === undefined) {
    return undefined;
  }
  throw new Error(
    'dateTimeMoment is not a valid Moment object, cannot parse to string.'
  );
}

export function parseTimeString(timeString, format) {
  if (timeString === undefined || timeString === '') {
    return null;
  }
  return moment(timeString, 'HH:mm').format(format);
}

export function parseTimeDateStringToMoment(dateTimeString, timeZone) {
  const timeMoment = moment.tz(dateTimeString, 'HHmm DDMMYYYY', timeZone);
  if (timeMoment.isValid()) {
    return timeMoment;
  }
  if (
    dateTimeString === undefined ||
    dateTimeString === '' ||
    dateTimeString.split(' ')[0].length === 0
  ) {
    return undefined;
  }
  throw new Error(
    'timeString input is not in the valid HHmm format, cannot parse to moment object.'
  );
}

export function isBeforeOrEqual(baseMoment, assertAfterMoment) {
  return (
    baseMoment.isBefore(assertAfterMoment) ||
    baseMoment.isSame(assertAfterMoment)
  );
}

export function isUsingNextDayTimes(loungeLocalTime, loungeOpening) {
  return loungeOpening.isAfter(loungeLocalTime, 'day');
}

export function isBetweenTimes(queryMoment, momentBefore, momentAfter) {
  return momentBefore.isBefore(queryMoment) && momentAfter.isAfter(queryMoment);
}

export function getLangFromLocale(locale) {
  return locale.split('-')[0].split('_')[0];
}

export function getCurrentTimeForTimeZone(locale, timeZone) {
  /*
    We added locale('en') because before it was returning the day of the
    week in the language of the country you are on (cool moment feature)
    This will not affect moment globally, it
    will only affect it here when moment() creates a new moment instance
  */

  return typeof locale === 'undefined'
    ? moment().locale('en').tz(timeZone)
    : moment().locale(getLangFromLocale(locale)).tz(timeZone);
}

export function getCurrentDayForTimeZone(locale, timeZone) {
  return getCurrentTimeForTimeZone(locale, timeZone)
    .format('dddd')
    .toLowerCase();
}

const dayOfWeekToNum = (dow) => {
  switch (dow.toLowerCase()) {
    case 'monday':
      return 1;
    case 'tuesday':
      return 2;
    case 'wednesday':
      return 3;
    case 'thursday':
      return 4;
    case 'friday':
      return 5;
    case 'saturday':
      return 6;
    case 'sunday':
      return 7;
    default:
      return 1;
  }
};

export function getShorthandDay(day, format) {
  // Moment is clever enough to know what our locale is and return the day in the correct language.
  // moment().day(day) doesn't work correctly, so use set function which does
  const d = moment().isoWeekday(dayOfWeekToNum(day)).format(format);
  return d.slice(0, 1).toUpperCase() + d.slice(1);
}
